module.exports = __webpack_public_path__ + "img/yecaizhongxin.ac9ec988.png";